var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHeartRed = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4154 4.7698C27.4671 4.7698 28.5171 4.91813 29.5154 5.25313C35.6671 7.25313 37.8837 14.0031 36.0321 19.9031C34.9821 22.9181 33.2654 25.6698 31.0171 27.9181C27.7987 31.0348 24.2671 33.8015 20.4654 36.1848L20.0487 36.4365L19.6154 36.1681C15.8004 33.8015 12.2487 31.0348 9.00039 27.9015C6.76706 25.6531 5.04873 22.9181 3.98206 19.9031C2.09873 14.0031 4.31539 7.25313 10.5337 5.21813C11.0171 5.05146 11.5154 4.9348 12.0154 4.8698H12.2154C12.6837 4.80146 13.1487 4.7698 13.6154 4.7698H13.7987C14.8487 4.80146 15.8654 4.9848 16.8504 5.3198H16.9487C17.0154 5.35146 17.0654 5.38646 17.0987 5.41813C17.4671 5.53646 17.8154 5.6698 18.1487 5.85313L18.7821 6.13646C18.9351 6.21808 19.1069 6.3428 19.2553 6.45058C19.3494 6.51887 19.4341 6.58037 19.4987 6.6198C19.5259 6.63585 19.5536 6.65198 19.5814 6.66825C19.7243 6.75167 19.8732 6.83857 19.9987 6.9348C21.8504 5.5198 24.0987 4.75313 26.4154 4.7698ZM30.8487 16.7698C31.5321 16.7515 32.1154 16.2031 32.1654 15.5015V15.3031C32.2154 12.9681 30.8004 10.8531 28.6487 10.0365C27.9654 9.80146 27.2154 10.1698 26.9654 10.8698C26.7321 11.5698 27.0987 12.3365 27.7987 12.5848C28.8671 12.9848 29.5821 14.0365 29.5821 15.2015V15.2531C29.5504 15.6348 29.6654 16.0031 29.8987 16.2865C30.1321 16.5698 30.4821 16.7348 30.8487 16.7698Z",
    fill: "url(#paint0_linear_1606_27736)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1606_27736",
    x1: 36.6657,
    y1: 36.4365,
    x2: -2.66883,
    y2: 24.4315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6B81"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHeartRed);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/heartRed.6b1404c4a9a1f2c9ce94a3905fea18a2.svg";